<template>
  <div class="min-h-screen bg-carpatina-bg font-sans">
    
    <header class="bg-carpatina-gri text-white shadow-xl border-b-4 border-carpatina-portocaliu sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 md:px-10 py-3 md:py-4 flex flex-col md:flex-row justify-between items-center gap-4">
        
        <div class="w-full md:w-auto flex justify-between items-center">
          <div class="flex items-center gap-3">
            <div class="bg-white p-1 rounded-lg shadow-md">
              <img src="@/assets/logo.png" alt="Carpatina" class="h-8 md:h-10 w-auto">
            </div>
            <h2 class="font-black italic uppercase tracking-widest text-lg md:text-xl hidden sm:block">
              Panou <span class="text-carpatina-portocaliu">Admin</span>
            </h2>
            
            <a href="/" target="_blank" 
               class="ml-2 flex items-center gap-1.5 px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-lg text-[10px] font-bold uppercase tracking-tighter transition-all border border-white/5">
              <ExternalLink :size="14" class="text-carpatina-portocaliu" />
              <span class="hidden md:inline">Vezi Site-ul</span>
            </a>
          </div>

          <button @click="handleLogout" class="md:hidden p-2 text-red-400">
            <LogOut :size="20" />
          </button>
        </div>
        
        <div class="w-full md:w-auto overflow-x-auto no-scrollbar">
          <div class="flex bg-black/20 p-1 rounded-2xl gap-1 border border-white/10 min-w-max">
            
            <button @click="activeTab = 'catalog'" 
                    :class="activeTab === 'catalog' ? 'bg-carpatina-portocaliu text-white shadow-lg' : 'text-gray-300 hover:text-white'"
                    class="px-4 md:px-6 py-2 rounded-xl font-black text-[10px] md:text-xs uppercase transition-all flex items-center gap-2">
              <Package :size="16" /> <span class="whitespace-nowrap">Catalog</span>
            </button>
            
            <button @click="activeTab = 'marketing'" 
                    :class="activeTab === 'marketing' ? 'bg-carpatina-portocaliu text-white shadow-lg' : 'text-gray-300 hover:text-white'"
                    class="px-4 md:px-6 py-2 rounded-xl font-black text-[10px] md:text-xs uppercase transition-all flex items-center gap-2">
              <MegaphoneIcon :size="16" /> <span class="whitespace-nowrap">Marketing</span>
            </button>
            <button @click="activeTab = 'oferte'" 
                    :class="activeTab === 'oferte' ? 'bg-carpatina-portocaliu text-white shadow-lg' : 'text-gray-300 hover:text-white'"
                    class="px-4 md:px-6 py-2 rounded-xl font-black text-[10px] md:text-xs uppercase transition-all flex items-center gap-2">
              <ShoppingBag :size="16" /> <span class="whitespace-nowrap">Oferte</span>
            </button>
            <button @click="activeTab = 'mesaje'" 
                    :class="activeTab === 'mesaje' ? 'bg-carpatina-portocaliu text-white shadow-lg' : 'text-gray-300 hover:text-white'"
                    class="px-4 md:px-6 py-2 rounded-xl font-black text-[10px] md:text-xs uppercase transition-all flex items-center gap-2 relative">
              <Mail :size="16" /> <span class="whitespace-nowrap">Mesaje</span>
            </button>

          </div>
        </div>

        <button @click="handleLogout" class="hidden md:flex items-center gap-2 text-xs font-bold text-red-400 hover:text-red-300 transition uppercase italic">
          <LogOut :size="16" /> Ieșire
        </button>
      </div>
    </header>

    <main class="p-4 md:p-8 max-w-7xl mx-auto w-full">
      
      <div v-if="activeTab === 'catalog'" class="space-y-6 animate-fade-in">
        <div class="flex justify-between items-center bg-white p-6 rounded-3xl shadow-sm border-l-8 border-carpatina-verde text-wrap flex-wrap gap-4">
            <div>
                <h1 class="text-3xl font-black text-carpatina-gri uppercase tracking-tight">Gestiune Catalog</h1>
                <p class="text-sm text-gray-400 font-bold italic">Organizează materialele pe categorii și subcategorii</p>
            </div>
            
            <div class="flex gap-2">
                <button @click="openCategoryManager" class="bg-gray-100 hover:bg-gray-200 text-carpatina-gri px-4 py-4 rounded-2xl font-black flex items-center gap-2 shadow-sm transition-transform hover:scale-105 active:scale-95 uppercase tracking-tighter text-xs">
                    <Settings :size="18" /> Categorii
                </button>

                <button @click="openCategoryModal" class="bg-carpatina-gri hover:bg-opacity-90 text-white px-6 py-4 rounded-2xl font-black flex items-center gap-2 shadow-lg transition-transform hover:scale-105 active:scale-95 uppercase tracking-tighter text-xs">
                    <Tag :size="18" class="text-carpatina-portocaliu" /> Adaugă Categorie
                </button>
            </div>
        </div>
        <AdminProducts />
      </div>

      <div v-if="activeTab === 'marketing'" class="space-y-6 animate-fade-in">
         <AdminMarketing />
      </div>
      <div v-if="activeTab === 'oferte'" class="space-y-6 animate-fade-in">
              
        <div class="bg-white p-6 rounded-3xl shadow-sm border-l-8 border-carpatina-verde mb-8">
            <h1 class="text-3xl font-black text-carpatina-gri uppercase tracking-tight">Cererile de Oferta</h1>
            <p class="text-sm text-gray-400 font-bold italic">Răspunde rapid pentru a închide vânzarea</p>
        </div>
         <AdminOffer />
      </div>
      <div v-if="activeTab === 'mesaje'" class="space-y-6 animate-fade-in">
        <div class="bg-white p-6 rounded-3xl shadow-sm border-l-8 border-carpatina-portocaliu mb-8">
            <h1 class="text-3xl font-black text-carpatina-gri uppercase tracking-tight">Mesajele Clienților</h1>
            <p class="text-sm text-gray-400 font-bold italic">Răspunde rapid pentru a închide vânzarea</p>
        </div>
        <AdminContact />
      </div>

    </main>

    <div v-if="showCategoryManager" class="fixed inset-0 bg-carpatina-gri/80 backdrop-blur-sm z-[60] flex items-center justify-center p-4 animate-fade-in">
      <div class="bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden border-2 border-carpatina-gri">
        <div class="bg-gray-100 p-6 flex justify-between items-center border-b border-gray-200">
          <h3 class="font-black uppercase tracking-widest text-lg text-carpatina-gri flex items-center gap-2">
            <Settings :size="20" /> Ștergere Categorii
          </h3>
          <button @click="showCategoryManager = false" class="hover:text-red-500 transition"><XCircle :size="24" /></button>
        </div>

<div class="p-4 max-h-[60vh] overflow-y-auto space-y-1 custom-scrollbar">
    
    <div v-if="categoriiList.length === 0" class="text-center text-gray-400 py-4 font-bold">
        Nu există categorii.
    </div>

    <div v-for="cat in categoriiList" :key="cat.id" 
         class="flex justify-between items-center p-2 rounded-lg transition group border-b border-gray-100 hover:bg-blue-50/50"
         :class="cat.level === 0 ? 'bg-gray-50 mt-3 border-t border-gray-200' : ''">
  
      <div class="flex items-center" :style="{ paddingLeft: (cat.level * 24) + 'px' }">
          <span v-if="cat.level > 0" class="text-gray-300 mr-2 text-lg leading-none">↳</span>
          
          <div class="flex flex-col">
              <span class="text-sm uppercase tracking-tight" 
                    :class="cat.level === 0 ? 'font-black text-carpatina-gri text-base' : 'font-bold text-gray-600'">
                {{ cat.nume }}
              </span>
              <span v-if="cat.level === 0" class="text-[9px] text-carpatina-verde font-black uppercase">
                  Categorie Principală
              </span>
          </div>
      </div>

      <div class="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity"> 
          <button @click="editCategory(cat)" 
                  class="p-1.5 bg-white text-gray-400 hover:text-blue-500 rounded-md hover:bg-blue-100 transition shadow-sm border border-gray-200">
              <Pencil :size="14" />
          </button>

          <button @click="deleteCategory(cat.id, cat.nume)" 
                  class="p-1.5 bg-white text-gray-300 group-hover:text-red-500 rounded-md hover:bg-red-100 transition shadow-sm border border-gray-200">
              <Trash2 :size="14" />
          </button>
      </div>
    </div>

</div>

        <div class="p-4 bg-gray-50 text-center text-[10px] text-gray-400 font-bold border-t border-gray-200">
           ATENȚIE: Nu poți șterge categorii care au produse alocate.
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Swal from 'sweetalert2';
import axios from 'axios';
import { 
  Package, 
  Mail, 
  Tag, 
  LogOut,
  ExternalLink,
  Settings, // Iconiță nouă
  XCircle, // Iconiță nouă
  Trash2 ,  // Iconiță nouă
  MegaphoneIcon,
  Pencil,
  ShoppingBag,
} from 'lucide-vue-next';

import AdminMarketing from './AdminMarketing.vue'; // <--- NOU
import AdminProducts from './AdminProducts.vue';
import AdminContact from './AdminContact.vue';
import AdminOffer from './AdminOffer.vue';
const router = useRouter();
const activeTab = ref('catalog');

// --- STATE PENTRU MANAGER CATEGORII ---
const showCategoryManager = ref(false);
const categoriiList = ref([]);

// Funcție pentru a deschide managerul și a încărca datele
// Funcție pentru a deschide managerul și a încărca datele IERARHIC
const openCategoryManager = async () => {
    try {
        const res = await axios.get('/categorii');
        const rawCategories = res.data;
        
        const sortedList = [];

        // Funcție recursivă care "așează" categoriile în ordine
        // parentId = null (începem cu rădăcinile)
        // level = 0 (nivelul de indentare)
        const buildHierarchy = (parentId, level) => {
            // 1. Găsim toți copiii părintelui curent
            const children = rawCategories.filter(c => c.parent_id === parentId);
            
            // 2. Îi sortăm alfabetic (opțional, dar arată mai bine)
            children.sort((a, b) => a.nume.localeCompare(b.nume));

            // 3. Îi adăugăm în lista finală și căutăm copiii lor
            children.forEach(child => {
                // Adăugăm o proprietate temporară 'level' pentru afișare
                child.level = level; 
                sortedList.push(child);
                
                // RECURSIVITATE: Căutăm copiii acestui copil (level + 1)
                buildHierarchy(child.id, level + 1);
            });
        };

        // Pornim construcția de la nivelul 0 (categorii fără părinte)
        buildHierarchy(null, 0);

        categoriiList.value = sortedList;
        showCategoryManager.value = true;
    } catch (err) {
        console.error(err);
        Swal.fire('Eroare', 'Nu am putut încărca categoriile', 'error');
    }
};
const editCategory = async (catToEdit) => {
    // 1. Pregătim lista de părinți (trebuie să excludem categoria curentă)
    const buildTreeOptions = (items, excludeId, selectedParentId, parentId = null, level = 0) => {
        let html = '';
        const children = items.filter(item => item.parent_id === parentId);
        
        children.forEach(child => {
            // Sărim peste categoria pe care o edităm
            if (child.id === excludeId) return;

            const prefix = level > 0 ? '&nbsp;&nbsp;'.repeat(level) + '↳ ' : '';
            const isSelected = child.id === selectedParentId ? 'selected' : '';
            const style = level === 0 ? 'font-weight: bold; color: #00684a;' : 'color: #444;';
            
            html += `<option value="${child.id}" ${isSelected} style="${style}">${prefix}${child.nume}</option>`;
            html += buildTreeOptions(items, excludeId, selectedParentId, child.id, level + 1);
        });
        return html;
    };

    const optionsHtml = `
        <option value="" ${catToEdit.parent_id === null ? 'selected' : ''}>Categorie Principală (Top Level)</option>
        ${buildTreeOptions(categoriiList.value, catToEdit.id, catToEdit.parent_id)}
    `;

    // 2. Afișăm Modalul (MODIFICAT AICI PENTRU ASPECT)
    const { value: formValues } = await Swal.fire({
        title: '<span class="uppercase font-black text-carpatina-gri">Editare Categorie</span>',
        html: `
            <div class="text-left flex flex-col gap-4"> <div>
                    <label class="text-[10px] font-bold uppercase text-gray-400 ml-1 block">Nume Nou</label>
                    <input id="edit-swal-nume" class="swal2-input !mt-1 !w-full !mx-0" value="${catToEdit.nume}">
                </div>

                <div>
                    <label class="text-[10px] font-bold uppercase text-carpatina-portocaliu ml-1 block flex items-center gap-1">
                        <span class="text-gray-400">Mută în:</span> (Părinte)
                    </label>
                    <select id="edit-swal-parent" class="swal2-input !mt-1 !w-full !mx-0">
                        ${optionsHtml}
                    </select>
                    <p class="text-[9px] text-gray-400 italic mt-1 ml-1">
                       Selectează "Categorie Principală" dacă vrei să fie sus de tot.
                    </p>
                </div>

            </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: '#3b82f6',
        confirmButtonText: 'SALVEAZĂ',
        cancelButtonText: 'Renunță',
        preConfirm: () => {
            const nume = document.getElementById('edit-swal-nume').value;
            if (!nume) {
                Swal.showValidationMessage('Numele este obligatoriu!');
            }
            return {
                nume: nume,
                parent_id: document.getElementById('edit-swal-parent').value || null
            }
        }
    });

    // 3. Trimitem datele la Backend (PATCH)
    if (formValues) {
        try {
            const fd = new FormData();
            fd.append('nume', formValues.nume);
            // Dacă a selectat ceva trimitem ID-ul, altfel nu trimitem nimic (ceea ce Backend-ul va interpreta ca NULL/None datorită logicii modificate sau trebuie să ne asigurăm că backend-ul acceptă gol)
            // *Fix pentru Backend:* Dacă e gol string-ul, nu îl adăuga, sau trimite un flag special.
            // Dar cel mai simplu: dacă e gol string-ul, înseamnă că vrea să fie root.
            
            // ATENȚIE: FormData trimite string-uri. "null" string nu e null python.
            // Putem trimite doar parent_id dacă există.
            
            // Backend-ul tău actualiza: `db_cat.parent_id = parent_id`.
            // Dacă trimitem string gol "", int(Form(None)) va crăpa în Python dacă nu e gestionat.
            // Soluție rapidă: trimitem doar dacă are valoare. Dacă e gol, trimitem request separat sau modificăm backend să accepte string gol ca None.
            
            // Varianta sigură Frontend -> Backend Python (FastAPI):
            if (formValues.parent_id) {
                 fd.append('parent_id', formValues.parent_id);
            } else {
                 // Ca să putem seta pe NULL (Top Level), trebuie să trimitem ceva gol, 
                 // dar FastAPI Form(Optional[int]) s-ar putea să se supere pe string gol.
                 // TRUC: Nu trimitem câmpul parent_id deloc aici (dacă e gol), 
                 // DAR backend-ul trebuie să știe că lipsa lui înseamnă "nu modifica" sau "pune null"?
                 // În cazul tău: `db_cat.parent_id = parent_id`. Dacă parent_id e None (lipsă), îl face None.
                 // Deci e corect să nu îl punem în FormData dacă e gol string-ul.
            }

            // PENTRU A FI SIGURI CĂ PUTEM MUTA ÎNAPOI PE "TOP LEVEL":
            // Modifică linia de axios să arate așa:
            const url = `/admin/categorie/${catToEdit.id}`;
            
            // Daca formValues.parent_id e gol (""), inseamna ca vrem NULL in baza de date.
            // FormData nu suporta null direct.
            // Trimiterea form-data e tricky cu null. 
            // Putem face un artificiu in backend sau trimitem '' si speram ca Python il vede ca None.
            
            // Solutia PRO: Modifica in backend `parent_id` sa accepte si string gol si converteste.
            // SAU, pur si simplu trimite parent_id doar daca e valid.
            if(formValues.parent_id) fd.append('parent_id', formValues.parent_id);
            
            // Dacă vrei să muți o subcategorie înapoi ca Principală, logica actuală din backend 
            // `db_cat.parent_id = parent_id` va pune None doar dacă `parent_id` e None.
            // FormData trimite text.
            
            await axios.patch(url, fd);

            Swal.fire({ title: 'Actualizat!', icon: 'success', timer: 1500, showConfirmButton: false });
            openCategoryManager();

        } catch (err) {
            Swal.fire('Eroare', 'Nu s-a putut actualiza categoria.', 'error');
        }
    }
};

// Funcție de ștergere efectivă
const deleteCategory = async (id, nume) => {
    const result = await Swal.fire({
        title: 'Ștergi categoria?',
        html: `Ești sigur că vrei să ștergi <b>${nume}</b>?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Da, șterge!',
        cancelButtonText: 'Renunță'
    });

    if (result.isConfirmed) {
        try {
            await axios.delete(`/admin/categorie/${id}`);
            
            Swal.fire({
                icon: 'success',
                title: 'Șters!',
                text: 'Categoria a fost eliminată.',
                timer: 1500,
                showConfirmButton: false
            });

            // Reîncărcăm lista locală
            openCategoryManager();
            
            // Opțional: Refresh la toată pagina dacă vrei să se actualizeze și dropdown-ul din AdminProducts
            // window.location.reload(); 
        } catch (err) {
            // Aici prindem eroarea de la Backend (dacă are produse)
            const errorMsg = err.response?.data?.detail || err.response?.data?.error || 'A apărut o eroare.';
            Swal.fire('Nu s-a putut șterge', errorMsg, 'error');
        }
    }
};

// --- LOGICA VECHE PENTRU ADAUGARE (RĂMÂNE LA FEL) ---
const openCategoryModal = async () => {
    try {
        const res = await axios.get('/categorii');
        const toateCategoriile = res.data;

        // Funcție recursivă pentru a crea opțiunile cu indentare
        const buildTreeOptions = (items, parentId = null, level = 0) => {
            let html = '';
            const children = items.filter(item => item.parent_id === parentId);
            
            children.forEach(child => {
                const prefix = level > 0 ? '&nbsp;&nbsp;'.repeat(level) + '↳ ' : '';
                const style = level === 0 ? 'font-weight: bold; color: #00684a;' : 'color: #444;';
                
                html += `<option value="${child.id}" style="${style}">${prefix}${child.nume}</option>`;
                
                // Căutăm sub-categorii pentru acest copil (recursivitate)
                html += buildTreeOptions(items, child.id, level + 1);
            });
            return html;
        };

        const optionsHtml = `
            <option value="">Categorie Principală (Top Level)</option>
            ${buildTreeOptions(toateCategoriile)}
        `;

        const { value: formValues } = await Swal.fire({
            title: '<span class="uppercase font-black text-carpatina-gri">Configurare Categorie</span>',
            html: `
                <div class="text-left">
                    <label class="text-[10px] font-bold uppercase text-gray-400 ml-1">Nume Categorie</label>
                    <input id="swal-input1" class="swal2-input !mt-1 !mb-4" placeholder="Ex: Ciment și Mortare">
                    
                    <label class="text-[10px] font-bold uppercase text-gray-400 ml-1">Alege Părintele (Unde o plasăm?)</label>
                    <select id="swal-input2" class="swal2-input !mt-1">
                        ${optionsHtml}
                    </select>
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#00684a',
            confirmButtonText: 'CREEAZĂ ACUM',
            cancelButtonText: 'ANULEAZĂ',
            customClass: {
                popup: 'rounded-3xl',
                confirmButton: 'rounded-xl font-black italic',
                cancelButton: 'rounded-xl font-bold'
            },
            preConfirm: () => {
                const nume = document.getElementById('swal-input1').value;
                if (!nume) {
                    Swal.showValidationMessage('Numele este obligatoriu!');
                }
                return {
                    nume: nume,
                    parent_id: document.getElementById('swal-input2').value
                }
            }
        });

        if (formValues) {
            const formData = new FormData();
            formData.append('nume', formValues.nume);
            if (formValues.parent_id) {
                formData.append('parent_id', formValues.parent_id);
            }

            await axios.post('/admin/categorie', formData);
            
            Swal.fire({ 
                icon: 'success', 
                title: 'Structură actualizată!', 
                toast: true, 
                position: 'top-end', 
                showConfirmButton: false, 
                timer: 2000 
            });
            
            window.location.reload();
        }
    } catch (err) {
        Swal.fire('Eroare', 'Nu am putut salva categoria.', 'error');
    }
};

onMounted(() => {
  if (!localStorage.getItem('carpatina_admin')) {
    router.push('/admin/login');
  }
  // --- SETĂRI SEO ȘI TITLU ---
  document.title = "Panou Administrare | Carpatina";
  
  // Instrucțiune pentru motoarele de căutare să NU indexeze această pagină
  const robotsMeta = document.querySelector('meta[name="robots"]') 
                     || document.createElement('meta');
  robotsMeta.name = "robots";
  robotsMeta.content = "noindex, nofollow";
  if (!document.querySelector('meta[name="robots"]')) {
    document.head.appendChild(robotsMeta);
  }
});

const handleLogout = () => {
  Swal.fire({
    title: 'Te deconectezi?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#00684a',
    cancelButtonColor: '#f08119',
    confirmButtonText: 'Da, pa!',
    cancelButtonText: 'Nu'
  }).then((result) => {
    if (result.isConfirmed) {
      localStorage.removeItem('carpatina_admin');
      router.push('/admin/login');
    }
  });
};



</script>

<style>
.animate-fade-in { animation: fadeIn 0.3s ease-in; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
.no-scrollbar::-webkit-scrollbar { display: none; }
.no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
</style>